var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { observer } from 'mobx-react';

import { CheckboxFieldEditor } from '../../../check/box';

var BooleanEdit = observer(function (_ref) {
  var field = _ref.field,
      _ref$locale = _ref.locale,
      locale = _ref$locale === undefined ? {} : _ref$locale,
      props = _objectWithoutProperties(_ref, ['field', 'locale']);

  return React.createElement(CheckboxFieldEditor, _extends({ field: field, locale: locale }, props));
});
export { BooleanEdit };